<template lang="html" src="./performance.section.html"></template>
<style lang="scss" scoped src="./_performance.section.mobile.scss"></style>
<style lang="scss" scoped src="./_performance.section.desktop.scss"></style>

<script>
export default {
  name: "PerformanceSection",
  props: ["isActive", "isLearnMoreActive"],
  data() {
    return {
      currSlide: "first"
    };
  },
  methods: {
    openLearnMore() {
      if (!this.isLearnMoreActive) {
        this.$emit("learn-more", "performance");
      }
    },
    closeLearnMore() {
      this.$emit("learn-more", "main");
    },
    changeSlide(slide) {
      const slideImg = document.querySelector(".subsection-2 > .img");
      slideImg.classList = `img ${slide}`;
      this.currSlide = slide;
    }
  }
};
</script>
